module.exports = __webpack_public_path__ + "public/adminIcons/config.svg?b7f8601c";